import { Platform } from './types'
import GoogleIcon from '../../../assets/img/google.svg'
import MetaIcon from '../../../assets/img/meta.svg'
import MicrosoftIcon from '../../../assets/img/microsoft.svg'
import { FiCheck } from 'react-icons/fi'

interface SelectedAccountBannerProps {
	platform: Platform
	accountName?: string
	accountNumber?: string
}

export const SelectedAccountBanner = ({
	platform,
	accountName,
	accountNumber
}: SelectedAccountBannerProps) => {
	const platformNames = {
		GADS: 'Google Ads',
		FADS: 'Meta Ads',
		BADS: 'Microsoft Ads'
	}

	const icons = {
		GADS: GoogleIcon,
		FADS: MetaIcon,
		BADS: MicrosoftIcon
	}

	const displayName = accountName || accountNumber || platformNames[platform]

	return (
		<div className="bg-white">
			<div className="flex items-center gap-[16px]">
				<div className="flex flex-1 items-center gap-[16px]">
					<img
						src={icons[platform]}
						alt={platformNames[platform]}
						className="w-[40px] h-[40px]"
					/>
					<div className="flex flex-col">
						<span className="text-[18px] leading-[28px] font-medium text-t-default">
							{displayName}
						</span>
						{accountNumber && (
							<span className="text-[16px] leading-[22px] text-t-checkbox-unactive">
								{accountNumber}
							</span>
						)}
					</div>
				</div>
			</div>
		</div>
	)
}
